// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ghost[data-v-13bdad2e] {\r\n  opacity: 0.5;\r\n  background: #c8ebfb;\n}\n.custom-reorganize-btn[data-v-13bdad2e] {\r\n  background-color: #405c64;\n}\n.outline-dark-gray[data-v-13bdad2e] {\r\n  color: #3f5b60;\r\n  background-color: #ffffff;\r\n  border-color: #3f5b60;\n}\r\n", ""]);
// Exports
module.exports = exports;
